var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.459 79.853C30.459 90.7192 39.3498 99.6101 50.2161 99.6101C61.0823 99.6101 69.9731 90.7192 69.9731 79.853V69.5635H30.459V79.853Z",
    fill: "url(#paint0_linear_2297_29116)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2622 30.0459H69.9727V69.56H80.2622C91.1284 69.56 100.019 60.6692 100.019 49.803C100.019 38.9367 91.1284 30.0459 80.2622 30.0459Z",
    fill: "url(#paint1_linear_2297_29116)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9731 19.7571C69.9731 8.89081 61.0822 0 50.216 0C39.3497 0 30.4589 8.89081 30.4589 19.7571V30.0466H19.7571C8.89081 30.0466 0 38.9374 0 49.8036C0 60.6699 8.89081 69.5607 19.7571 69.5607H69.9731V19.7571Z",
    fill: "url(#paint2_linear_2297_29116)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2297_29116",
    x1: 50.2161,
    y1: 69.5608,
    x2: 50.2161,
    y2: 99.6101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#243362"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#364880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#445997"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#4E64A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#546BB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#566EB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2297_29116",
    x1: 69.9727,
    y1: 49.803,
    x2: 100.022,
    y2: 49.803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#243362"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#364880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#445997"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#4E64A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#546BB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#566EB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2297_29116",
    x1: 58.7942,
    y1: 76.0152,
    x2: 22.417,
    y2: 13.0115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#C92128"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#CC282D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#D73D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E75B54"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo3);
export default __webpack_public_path__ + "static/media/Logo_3.9db9dc32d4b7ee01e70e681f6d613dfd.svg";
export { ForwardRef as ReactComponent };